<template>
  <div>
    <!--    <div class="d-flex justify-space-between mb-3">-->
    <!--      <div class="d-flex ga-2">-->
    <!--        <span class="text-disabled"> Версія {{ currentFile.version }} </span>-->
    <!--        <div v-tooltip="currentFile.name" class="text-truncate">-->
    <!--          <span>{{ currentFile.name }}</span>-->
    <!--        </div>-->
    <!--      </div>-->

    <!--      <v-menu>-->
    <!--        <template #activator="{ props }">-->
    <!--          <v-btn density="comfortable" color="black" v-bind="props">-->
    <!--            <span class="mr-2">Версії</span>-->
    <!--            <v-icon icon="mdi-chevron-down"></v-icon>-->
    <!--          </v-btn>-->
    <!--        </template>-->

    <!--        <v-card style="width: 400px">-->
    <!--          <v-card-text>-->
    <!--            <div v-for="(file, idx) in files.toReversed()" :key="file.id">-->
    <!--              <div class="d-flex justify-space-between align-end mb-3">-->
    <!--                <div class="font-weight-bold">-->
    <!--                  <span class="font-weight-bold">-->
    <!--                    Версія {{ file.version }}-->
    <!--                  </span>-->

    <!--                  <v-chip-->
    <!--                    v-if="file.version === documentAgreementSource.file.version"-->
    <!--                    density="compact"-->
    <!--                    class="rounded-pill ml-3"-->
    <!--                    color="black">-->
    <!--                    Поточна-->
    <!--                  </v-chip>-->
    <!--                </div>-->

    <!--                <v-btn-->
    <!--                  v-if="currentFile.id !== file.id"-->
    <!--                  density="compact"-->
    <!--                  variant="outlined"-->
    <!--                  color="grey"-->
    <!--                  @click="currentFile = file">-->
    <!--                  <span class="mr-2">Переглянути</span>-->
    <!--                  <v-icon icon="mdi-eye"></v-icon>-->
    <!--                </v-btn>-->
    <!--              </div>-->

    <!--              <div v-tooltip="file.name" class="text-truncate mb-1">-->
    <!--                {{ file.name }}-->
    <!--              </div>-->

    <!--              <div class="text-disabled">-->
    <!--                {{ formatFileSize(file.size) }} |-->
    <!--                {{ new CustomDate(file.created_at).toString({ time: true }) }}-->
    <!--              </div>-->

    <!--              <v-divider v-if="files.length - 1 > idx" class="my-2"></v-divider>-->
    <!--            </div>-->
    <!--          </v-card-text>-->
    <!--        </v-card>-->
    <!--      </v-menu>-->
    <!--    </div>-->
    <document-preview
      id="document-preview"
      :key="currentFile.id"
      :style="{ height: documentPreviewHeight }"
      :document="currentFile"></document-preview>
  </div>
</template>

<script lang="ts">
import DocumentPreview from '@/components/document-page-template/DocumentPreview.vue'
import { useDocumentAgreement } from '../documentAgreement'
import { nextTick, onMounted, ref, watch } from 'vue'
import { formatFileSize } from '@/utils/helpers'
import { CustomDate } from 'best-modules/utils'

export default {
  name: 'Preview',
  components: { DocumentPreview },
  methods: { CustomDate },
  setup() {
    const { isInitialized, currentFile, documentAgreementSource, files } =
      useDocumentAgreement()
    const documentPreviewHeight = ref<string>('100%')
    const setDocumentPreviewHeight = () => {
      if (!document) return

      nextTick(() => {
        const documentPreviewElement =
          document.getElementById('document-preview')!

        if (documentPreviewElement) {
          documentPreviewHeight.value = `calc(100vh - ${
            documentPreviewElement.getBoundingClientRect().top
          }px - 28px)`
          // documentPreviewHeight.value =
          //   documentPreviewElement.clientWidth * 1.41 + 'px'
        }
      })
    }

    onMounted(() => {
      if (isInitialized.value) {
        setDocumentPreviewHeight()
      } else {
        watch(isInitialized, setDocumentPreviewHeight, { once: true })
      }
    })

    return {
      documentPreviewHeight,
      currentFile,
      documentAgreementSource,
      files,
      formatFileSize,
    }
  },
}
</script>

<style scoped lang="scss"></style>
